module.exports = Object.freeze({
  EMAIL: "email",
  PHONE: "phone",
});
